import { cn } from '@core/utils';

import type { Size } from './types';

interface LogoContainerProps {
  size?: Size;
  children: React.ReactNode;
}

export const LogoContainer = ({ size, children }: LogoContainerProps) => {
  return (
    <div
      className={cn('flex shrink-0 items-center justify-start pt-4', {
        'size-40': size === 40,
        'size-50': size === 50,
        'size-60': size === 60,
        'size-80': size === 80,
      })}
    >
      {children}
    </div>
  );
};
